import FileIcon from "@/modules/common/components/ui-kit/icons/file-icon";
import { Stack, Typography } from "@mui/material";
import ContractActionsMenu from "./actions-menu";
import { Annex, ContractStatus } from "@/modules/property-tracks/dtos/tenants";
import { formattedDate } from "@/modules/property-tracks/utils/rental-info";
import { capitalizeName } from "@/modules/common/utils";

export const ContractStatusLabel = ({ status }: { status: ContractStatus }) => {
  const getStatusColors = (status: ContractStatus) => {
    switch (status) {
      case "terminated":
      case "expired":
        return {
          label: capitalizeName(status),
          text: "#AB2018",
          bgcolor: "#FFC8C2",
        };
      case "pending_signature":
        return {
          label: capitalizeName(status.split("_").join(" ")),
          text: "#5D5D13",
          bgcolor: "#F3F3C4",
        };
      case "signed":
        return {
          label: capitalizeName(status),
          text: "#326054",
          bgcolor: "#CFE8E2",
        };
      case "about_to_expire":
        return {
          label: capitalizeName(status.split("_").join(" ")),
          text: "#B34B00",
          bgcolor: "#FFE3CC",
        };
      default:
        return {
          label: capitalizeName(status),
          text: "#313131",
          bgcolor: "#E0E0E0",
        };
    }
  };

  const formattedStatus = getStatusColors(status);

  return (
    <Stack
      bgcolor={formattedStatus.bgcolor}
      borderRadius={(theme) => theme.nawy.radius.md}
      p={(theme) => theme.nawy.spacing.xs}
      width="max-content"
      height={24}
      alignItems="center"
      justifyContent="center"
    >
      <Typography fontSize={11} fontWeight={600} color={formattedStatus.text}>
        {formattedStatus.label}
      </Typography>
    </Stack>
  );
};

function Contract({ contract }: Readonly<{ contract: Annex }>) {
  return (
    <Stack
      width="100%"
      key={contract.uid}
      direction="row"
      borderRadius={(theme) => theme.nawy.radius.xl}
      border="1px solid #E0E0E0"
      p={(theme) => theme.nawy.spacing.md}
      justifyContent="space-between"
      alignItems="center"
    >
      <Stack
        direction="row"
        gap={(theme) => theme.nawy.spacing.md}
        alignItems="center"
        flexWrap="wrap"
      >
        <FileIcon fileType="pdf" />

        <Stack>
          <Typography fontSize={14} fontWeight={600}>
            {contract.contractTemplate.name}
          </Typography>
          <Typography fontSize={12}>
            {formattedDate(contract.createdAt)}
          </Typography>
        </Stack>
      </Stack>
      <Stack
        direction="row"
        gap={(theme) => theme.nawy.spacing.xxs}
        alignItems="center"
        justifyContent="flex-end"
        flexWrap="wrap"
      >
        <ContractStatusLabel status={contract.status} />

        <ContractActionsMenu
          contractUid={contract.uid}
          endDate={contract.endDate}
        />
      </Stack>
    </Stack>
  );
}

export default Contract;
